import $ from './skizz'
import './plugins/dropdown'

if ($('.page--step-1').length > 0) {
  let country = $('.country')
  let countryImg = $('img', country)
  let countryLabel = $('.country-label', country)

  $('.country + .menu').on('click', 'li', function (event) {
    let active = $(event.target)
    let newLang = active.attr('data-name')

    countryLabel.text(active.text())
    countryImg.attr('src', $('img', active).attr('src'))
    $('#country-eid').attr('value', newLang)
  })

  $('.dropdown').dropdown({
    directParent: true
  })
}
